var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 572.614,
    height: 404.897,
    viewBox: "0 0 572.614 404.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(-82.446 -46.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M203.762,173.485H89.337a4.421,4.421,0,0,1-4.422-4.422h0a4.422,4.422,0,0,1,4.422-4.422H203.762a4.422,4.422,0,0,1,4.422,4.422h0A4.421,4.421,0,0,1,203.762,173.485Z",
    fill: "#85b9fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M414.614,55.259H340.066a4.526,4.526,0,0,1-4.526-4.526h0a4.527,4.527,0,0,1,4.526-4.527h74.548a4.527,4.527,0,0,1,4.527,4.527h0A4.526,4.526,0,0,1,414.614,55.259Z",
    fill: "#85b9fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_5",
    "data-name": "Ret\\xE2ngulo 5",
    d: "M6.259,0H19.413a6.259,6.259,0,0,1,6.259,6.259V18.607a6.259,6.259,0,0,1-6.259,6.259H6.258A6.258,6.258,0,0,1,0,18.607V6.259A6.259,6.259,0,0,1,6.259,0Z",
    transform: "translate(120.877 206.974)",
    fill: "#1071f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_6",
    "data-name": "Ret\\xE2ngulo 6",
    width: 14.006,
    height: 13.566,
    rx: 3.415,
    transform: "translate(512.336 437.537)",
    fill: "#e4eefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_7",
    "data-name": "Ret\\xE2ngulo 7",
    d: "M3.414,0h7.177a3.415,3.415,0,0,1,3.415,3.415v6.737a3.415,3.415,0,0,1-3.415,3.415H3.415A3.415,3.415,0,0,1,0,10.152V3.414A3.414,3.414,0,0,1,3.414,0Z",
    transform: "translate(641.053 149.841)",
    fill: "#1071f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M149.817,371.569l-36.239,18.774,10.441,5.056-12.965,15.5,10.117,8.283,12.523-16.644,8.395,9Z",
    fill: "#e4eefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M276,449.674H233.661A5.677,5.677,0,0,1,227.984,444h0a5.676,5.676,0,0,1,5.677-5.677H276A5.677,5.677,0,0,1,281.68,444h0A5.677,5.677,0,0,1,276,449.674Z",
    fill: "#85b9fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(-7.255 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8",
    "data-name": "Ret\\xE2ngulo 8",
    width: 355.309,
    height: 298.327,
    rx: 7.151,
    transform: "translate(199.588 111.123)",
    fill: "#e4eefc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_1",
    "data-name": "Linha 1",
    x2: 355.309,
    transform: "translate(199.588 147.02)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.941
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9",
    "data-name": "Ret\\xE2ngulo 9",
    width: 355.309,
    height: 298.327,
    rx: 7.151,
    transform: "translate(199.588 111.123)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.941
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 5.009,
    cy: 5.009,
    r: 5.009,
    transform: "translate(224.616 124.429)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.941
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 5.009,
    cy: 5.009,
    r: 5.009,
    transform: "translate(244.083 124.429)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.941
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 5.009,
    cy: 5.009,
    r: 5.009,
    transform: "translate(263.551 124.429)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.941
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_10",
    "data-name": "Ret\\xE2ngulo 10",
    width: 201.26,
    height: 87.64,
    rx: 10.354,
    transform: "translate(82.446 268.044)",
    fill: "#85b9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M106.854,284.317a3.811,3.811,0,1,1-3.811-3.811A3.811,3.811,0,0,1,106.854,284.317Z",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.477
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 3.811,
    cy: 3.811,
    r: 3.811,
    transform: "translate(114.043 280.506)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.477
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 3.811,
    cy: 3.811,
    r: 3.811,
    transform: "translate(128.854 280.506)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.477
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_2",
    "data-name": "Linha 2",
    x2: 201.26,
    transform: "translate(82.446 298.743)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 1.477
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_11",
    "data-name": "Ret\\xE2ngulo 11",
    width: 105.478,
    height: 89.817,
    rx: 12.24,
    transform: "translate(504.6 66.984)",
    fill: "#85b9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M550.682,122.109a18.227,18.227,0,1,1,18.227-18.227A18.247,18.247,0,0,1,550.682,122.109Zm0-32.324a14.1,14.1,0,1,0,14.1,14.1A14.112,14.112,0,0,0,550.682,89.785Z",
    fill: "#fefef4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_12",
    "data-name": "Ret\\xE2ngulo 12",
    width: 4.13,
    height: 7.61,
    transform: "translate(560.63 116.79) rotate(-45)",
    fill: "#fefef4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 20.844,
    height: 9.134,
    rx: 2.892,
    transform: "translate(577.935 137.633) rotate(-135)",
    fill: "#fefef4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 74.816,
    height: 67.741,
    rx: 14.132,
    transform: "translate(107.987 60.901)",
    fill: "#1071f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M145.4,109.365a15.849,15.849,0,1,1,15.85-15.849A15.867,15.867,0,0,1,145.4,109.365Zm0-26.935a11.086,11.086,0,1,0,11.086,11.086A11.1,11.1,0,0,0,145.4,82.43Z",
    fill: "#fefef4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x1: 18.174,
    y2: 22.172,
    transform: "translate(136.563 82.43)",
    fill: "none",
    stroke: "#fefef4",
    strokeMiterlimit: 10,
    strokeWidth: 4.522
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/OBJECTS.823c7c64d7f9d7ac4ddd907357926b85.svg";
export { ForwardRef as ReactComponent };